import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React from 'react';
import { Col, Row } from 'antd';
import { Typography, VertContainer } from '@vertem-core/vertice-ds';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { formatToString } from 'Utils/format';
import { handleAddressNumberOutput } from 'Utils/commons/address';

export const SpotInfos = (
  {
    spot,
    isManager,
    callModalDocuments,
    isQuote = false
  }
) => {

  const addressDelivery = isQuote ? '' : spot.addresses.find((x) => x.type === 1);
  const addressPayment = isQuote ? '' : spot.addresses.find((x) => x.type === 2);

  const handleGetSignedTerm = ({ redemptionStatusId, files }) => {
    let signedTerm = '';

    if (files.length) {
      files.map((f) => {
        f.type === 2 && f.status === 1
        return signedTerm = f.url;
      })
    }

    if (redemptionStatusId === 6 && signedTerm.length) {
      return (
        <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
          <VertContainer className='container-details-view-redemption'>
            <Typography.Text className='text-view-redemption font-weight-700'>
              Termo Assinado
            </Typography.Text>
            <Typography.Text >
              <a className='link-view-redemption' href={signedTerm} target='_blank'>Download</a>
            </Typography.Text>
            <Typography.Text className='text-view-redemption'>
              <a className='link-view-redemption' onClick={() => callModalDocuments(1, signedTerm)} target='_blank'>Enviar Termo</a>
            </Typography.Text>
          </VertContainer>
        </Col>
      )
    }
  }

  const RedemptionStatusType = (value, admin) => {
    switch (value) {
      case 1:
        return (
          <Typography.Text className="status-pending">
            Aguardando cotação
          </Typography.Text>
        );
      case 2:
        return (
          <Typography.Text className="status-pending">
            {admin ? 'Pendente - PMO' : 'Pendente Syngenta'}
          </Typography.Text>
        );
      case 3:
        return (
          <Typography.Text className="status-pending">
            {admin ? 'Pendente - Líder' : 'Pendente Syngenta'}
          </Typography.Text>
        );
      case 4:
        return (
          <Typography.Text className="status-pending">
            Aguardando aprovação
          </Typography.Text>
        );
      case 5:
        return (
          <Typography.Text className="status-cancel">Cancelado</Typography.Text>
        );
      case 6:
        return (
          <Typography.Text className="status-approved">
            Aprovado
          </Typography.Text>
        );
      case 10:
        return (
          <Typography.Text type="warning">
            {admin ? 'Confirmação Líder' : 'Pendente Syngenta'}
          </Typography.Text>
        );
      default:
        return (
          <Typography.Text className="status-pending">Pendente</Typography.Text>
        );
    }
  }

  return (

    <Row className='container-summary-view-redemption' gutter={[32, 32]}>

      <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
        <VertContainer className='container-details-view-redemption'>
          <Typography.Text className='text-view-redemption font-weight-700'>
            Nome do Participante
          </Typography.Text>
          <Typography.Text className='text-view-redemption'>
            {spot.participantName}
          </Typography.Text>
        </VertContainer>
      </Col>

      <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
        <VertContainer className='container-details-view-redemption'>
          <Typography.Text className='text-view-redemption font-weight-700'>
            Data da Solicitação
          </Typography.Text>
          <Typography.Text className='text-view-redemption'>
            {format(new Date(spot.date), 'dd/MM/yyyy')}
          </Typography.Text>
        </VertContainer>
      </Col>

      {!isManager && (
        <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
          <VertContainer className='container-details-view-redemption'>
            <Typography.Text className='text-view-redemption font-weight-700'>
              Valor Total
            </Typography.Text>
          </VertContainer>
          <Typography.Text className='text-view-redemption'>
            {formatToString(spot.totalPrice, spot.type === 3 ? '' : 'currency')}
            {spot.type === 3 ? ' pontos' : ''}
          </Typography.Text>
        </Col>
      )}

      {isManager && !isQuote && (
        <>

          <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
            <VertContainer className='container-details-view-redemption'>
              <Typography.Text className='text-view-redemption font-weight-700'>
                Valor Total
              </Typography.Text>
              <Typography.Text className='text-view-redemption'>
                {formatToString(spot.totalPrice, spot.type === 3 ? '' : 'currency')}
                {spot.type === 3 ? ' pontos' : ''}
              </Typography.Text>
              {spot.type === 2 && spot.redemptionStatusId === 4 && spot.totalPriceWithoutTax && (
                <Typography.Text className='text-view-redemption'>
                  {`Sem taxa: ${formatToString(spot.totalPriceWithoutTax, 'currency')}`}
                </Typography.Text>
              )}
            </VertContainer>
          </Col>

          {(spot.type === 3) && (
            <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
              <VertContainer className='container-details-view-redemption'>
                <Typography.Text className='text-view-redemption font-weight-700'>
                  Total em pontos
                </Typography.Text>
                <Typography.Text className='text-view-redemption'>
                  {`${formatToString(spot.totalPoints, '')} pontos`}
                </Typography.Text>
                {(spot.redemptionStatusId === 4 && spot.totalPointsWithoutTax) && (
                  <Typography.Text className='text-view-redemption'>
                    {`Sem taxa: ${formatToString(spot.totalPointsWithoutTax, '')} pontos`}
                  </Typography.Text>
                )}
              </VertContainer>
            </Col>
          )}
        </>
      )}

      {spot.type !== 4 && (
        <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
          <VertContainer className='container-details-view-redemption'>
            <Typography.Text className='text-view-redemption font-weight-700'>
              Nome do Solicitante
            </Typography.Text>
            <Typography.Text className='text-view-redemption'>
              {spot.managerName}
            </Typography.Text>
          </VertContainer>
        </Col>
      )}

      <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
        <VertContainer className='container-details-view-redemption'>
          <Typography.Text className='text-view-redemption font-weight-700'>
            Status da Solicitação
          </Typography.Text>
          {RedemptionStatusType(spot.redemptionStatusId, isManager)}
        </VertContainer>
      </Col>

      {!isQuote && (
        <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
          <VertContainer className='container-details-view-redemption'>
            <Typography.Text className='text-view-redemption font-weight-700'>
              End. de Entrega
            </Typography.Text>
            <Typography.Text className='text-view-redemption'>
              {`${addressDelivery?.address}, ${handleAddressNumberOutput(addressDelivery?.number)}, ${addressDelivery?.city}`}
            </Typography.Text>
          </VertContainer>
        </Col>
      )}

      {addressPayment !== null &&
        addressPayment !== undefined &&
        addressPayment.length > 0 && (
          <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
            <VertContainer className='container-details-view-redemption'>
              <Typography.Text className='text-view-redemption font-weight-700'>
                End. de Faturamento
              </Typography.Text>
              <Typography.Text className='text-view-redemption'>
                {`${addressPayment.address}, ${handleAddressNumberOutput(addressPayment.number)}, ${addressPayment.city}`}
              </Typography.Text>
            </VertContainer>
          </Col>
        )
      }

      {!isQuote && (
        <Col xs={24} sm={24} md={12} lg={4} xl={4} xxl={4}>
          <VertContainer className='container-details-view-redemption'>
            <Typography.Text className='text-view-redemption font-weight-700'>
              Data Desejada
            </Typography.Text >
            <Typography.Text className='text-view-redemption'>
              {spot.forecastDate
                ? format(new Date(spot.forecastDate), 'dd/MM/yyyy')
                : '---'}
            </Typography.Text>
          </VertContainer>
        </Col>
      )}
      {handleGetSignedTerm(spot)}
    </Row>
  )
}

SpotInfos.propTypes = {
  spot: PropTypes.object.isRequired,
  isManager: PropTypes.bool.isRequired,
  callModalDocuments: PropTypes.func,
  isQuote: PropTypes.bool,
};